import { render, staticRenderFns } from "./OrderSet.vue?vue&type=template&id=5b0a0710&scoped=true&"
import script from "./OrderSet.vue?vue&type=script&lang=js&"
export * from "./OrderSet.vue?vue&type=script&lang=js&"
import style0 from "./OrderSet.vue?vue&type=style&index=0&id=5b0a0710&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a0710",
  null
  
)

export default component.exports